<template>
  <div class="attendance-grid">
    <div v-if="loading" class="loading-container">
      <div class="loading-content">
        <Spin size="large">
          <Icon type="ios-loading" size="48" class="spin-icon-load"></Icon>
        </Spin>
        <p class="loading-text">{{ $t('loadingPhotos') || 'Loading photos...' }}</p>
      </div>
    </div>
    
    <div v-else-if="hasAttendances" class="date-groups-wrapper">
      <transition-group name="fade-slide" tag="div" class="date-groups">
        <attendance-date-group
          v-for="(items, date) in attendances"
          :key="date"
          :date="date"
          :items="items"
        />
      </transition-group>
    </div>
    
    <div v-else class="empty-state">
      <div class="empty-state-content">
        <div class="empty-icon-wrapper">
          <Icon type="ios-images" size="80" class="empty-icon" />
        </div>
        <h3 class="empty-title">{{ $t('attendanceGallery.noAttendancePhotos') || 'No attendance photos found' }}</h3>
        <p class="empty-description">{{ $t('attendanceGallery.tryAdjustingFilters') || 'Try adjusting your date range or organization filters to see attendance photos' }}</p>
        <div class="empty-suggestions">
          <div class="suggestion-item">
            <Icon type="ios-calendar" size="18" />
            <span>Select a different date range</span>
          </div>
          <div class="suggestion-item">
            <Icon type="ios-business" size="18" />
            <span>Choose a different organization</span>
          </div>
          <div class="suggestion-item">
            <Icon type="ios-person" size="18" />
            <span>Clear employee filters</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AttendanceDateGroup from './AttendanceDateGroup.vue'

export default {
  name: 'AttendanceGalleryGrid',
  components: {
    AttendanceDateGroup
  },
  props: {
    attendances: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasAttendances() {
      return Object.keys(this.attendances).length > 0
    }
  }
}
</script>

<style scoped lang="scss">
.attendance-grid {
  min-height: 60vh;
  
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
    
    .loading-content {
      text-align: center;
      color: white;
      
      .loading-text {
        margin-top: 16px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }
  }
  
  .date-groups-wrapper {
    .date-groups {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
  
  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    padding: 40px 20px;
    
    .empty-state-content {
      text-align: center;
      max-width: 500px;
      
      .empty-icon-wrapper {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 140px;
        height: 140px;
        border-radius: 50%;
        margin-bottom: 32px;
        box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
        
        .empty-icon {
          color: white;
        }
      }
      
      .empty-title {
        font-size: 24px;
        color: #17233d;
        margin-bottom: 12px;
        font-weight: 700;
      }
      
      .empty-description {
        color: #808695;
        font-size: 15px;
        line-height: 1.6;
        margin-bottom: 32px;
      }
      
      .empty-suggestions {
        display: flex;
        flex-direction: column;
        gap: 12px;
        text-align: left;
        background: #f7f8fa;
        padding: 24px;
        border-radius: 12px;
        border: 2px dashed #dcdee2;
        
        .suggestion-item {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #515a6e;
          font-size: 14px;
          font-weight: 500;
          
          i {
            color: #667eea;
          }
        }
      }
    }
  }
  
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.4s ease;
  }
  
  .fade-slide-enter {
    opacity: 0;
    transform: translateY(20px);
  }
  
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
